import styled from 'styled-components'

export const PoweredBy = styled.div`
  text-align: center;
  margin-bottom: 30px;

  img {
    width: 290px;
  }
`
